<template>
  <div>
    <FormulateForm :schema="schema"
                   v-model="values"></FormulateForm>
  </div>
</template>

<script>
export default {
  props: {
    schema: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      values: {}
    }
  },
  mounted() {
    console.log("mounted");
  }
}
</script>

<style scoped>

</style>
